import { Arg, Metadata } from '../../../../../utils/spds/metadata';
import FlexRow from '../../../layout/flex/row.gjs';
import Super from '../../../core/base.gjs';

const METADATA = Metadata.define({
  description: 'Body text content for the alert banner message',
  meta: {
    body: Arg.string({ description: 'Body text content' }).required(),
  },
  name: 'Alert Banner Message Body',
});

export default class SpdsFeedbackAlertBannerMessageBody extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-feedback-alert-banner-message-body';

  <template>
    <FlexRow
      @content={{@body}}
      class={{this.classes}}
      data-test-spds-feedback-alert-banner-message-body
      {{this.validateArguments}}
      ...attributes
    />
  </template>
}

export const ALERT_BANNER_MESSAGE_BODY_METADATA = SpdsFeedbackAlertBannerMessageBody.metadata;
